"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANALYSIS_FILE_LABEL_TO_SYSTEM_LABEL = exports.AnalysisFileLabel = exports.DEPRECATED_SYSTEM_LABEL_KEYS = exports.DEPRECATED_SYSTEM_LABELS = exports.SystemLabel = void 0;
var SystemLabel;
(function (SystemLabel) {
    SystemLabel["BRAND_FONT"] = "Brand Font";
    SystemLabel["BRAND_ASSET"] = "Brand Asset";
    // screenshot & recording labels
    SystemLabel["MOBILE_WEBSITE_SCREENSHOT"] = "Mobile Website Screenshot";
    SystemLabel["DESKTOP_WEBSITE_SCREENSHOT"] = "Desktop Website Screenshot";
    SystemLabel["APP_SCREENSHOT"] = "App Screenshot";
    SystemLabel["APP_SCREEN_RECORDING"] = "App Screen Recording";
    // app specific labels
    SystemLabel["APP_ICON"] = "App Icon";
    SystemLabel["APP_STORE_ASSET"] = "App Store Asset";
    // e-commerce specific labels
    SystemLabel["ECOMMERCE_PRODUCT_IMAGE"] = "E-commerce Product Photo";
    // creative/ad element labels
    SystemLabel["END_CARD"] = "End Card";
})(SystemLabel || (exports.SystemLabel = SystemLabel = {}));
/**
 * System labels that are no longer user-assignable. They are hidden from the label
 * picker UI and excluded from auto-categorization. Existing label connections stay
 * intact, and the analysis pipeline continues to apply these labels for generation
 * templates that depend on them.
 */
exports.DEPRECATED_SYSTEM_LABELS = [SystemLabel.APP_ICON];
/**
 * `Label.systemIdentifier` values in the database for {@link DEPRECATED_SYSTEM_LABELS}
 * (enum keys, e.g. `APP_ICON` — not the human-readable enum values).
 */
exports.DEPRECATED_SYSTEM_LABEL_KEYS = ['APP_ICON'];
/**
 * Human-readable string enum the analysis pipeline assigns to files instead of
 * numeric DB label IDs. Values are self-describing and align with the
 * {@link SystemLabel} values where a system label exists. `BRAND_LOGO` is an
 * analysis-only descriptor (no dedicated system label) and resolves to
 * `Brand Asset` at persistence time.
 *
 * Lives in `shared` so both the API and the background event schema
 * (`backend-lib`) reference a single source of truth.
 */
var AnalysisFileLabel;
(function (AnalysisFileLabel) {
    AnalysisFileLabel["BRAND_ASSET"] = "Brand Asset";
    AnalysisFileLabel["APP_ICON"] = "App Icon";
    AnalysisFileLabel["APP_STORE_ASSET"] = "App Store Asset";
    AnalysisFileLabel["ECOMMERCE_PRODUCT_PHOTO"] = "E-commerce Product Photo";
    AnalysisFileLabel["BRAND_LOGO"] = "Brand Logo";
})(AnalysisFileLabel || (exports.AnalysisFileLabel = AnalysisFileLabel = {}));
/**
 * Maps the analysis-only {@link AnalysisFileLabel} enum to the persistable
 * {@link SystemLabel}. `Brand Logo` has no dedicated system label and folds
 * into `Brand Asset`.
 */
exports.ANALYSIS_FILE_LABEL_TO_SYSTEM_LABEL = {
    [AnalysisFileLabel.BRAND_ASSET]: SystemLabel.BRAND_ASSET,
    [AnalysisFileLabel.APP_ICON]: SystemLabel.APP_ICON,
    [AnalysisFileLabel.APP_STORE_ASSET]: SystemLabel.APP_STORE_ASSET,
    [AnalysisFileLabel.ECOMMERCE_PRODUCT_PHOTO]: SystemLabel.ECOMMERCE_PRODUCT_IMAGE,
    [AnalysisFileLabel.BRAND_LOGO]: SystemLabel.BRAND_ASSET,
};
